import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "draft",
  COLLECTIONS: {
    BAILIFF: "bailiff",
    DIALOG: "dialog",
    //
    DIALOG_EDITED: "dialogEdited",
    VOICE_SAMPLE: "voiceSample",
    COMMENT: "comment",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    bailiff: collection(firestore, REF.COLLECTIONS.BAILIFF),
    dialog: collection(firestore, REF.COLLECTIONS.DIALOG),
    dialogEdited: collection(firestore, REF.COLLECTIONS.DIALOG_EDITED),
    voiceSample: collection(firestore, REF.COLLECTIONS.VOICE_SAMPLE),
    comment: collection(firestore, REF.COLLECTIONS.COMMENT),
  };
  return CREF;
};
